type Options = {
    start: number;
    end: number;
    target: number;
    duration: number;
};

export function calculateStartingExtremes({ start, end, target, duration }: Options) {
    if (start > end) {
        return null;
    }

    // Edge case: target is before both start and end
    if (target < start) {
        // - min extreme is the start date
        // - max extreme is lesser of: min + `duration` time, or end
        return {
            min: start,
            max: Math.min(start + duration, end),
        };
    }

    const tentativeMax = Math.min(target, end);
    const tentativeMin = tentativeMax - duration; // May be less than start...

    // If tentativeMin is before start, determine by how much - this will be added to max instead (up to end)
    const remainder = Math.max(start - tentativeMin, 0);

    const min = Math.max(tentativeMin, start);
    const max = Math.min(tentativeMax + remainder, end);

    return { min, max };
}
